"use strict";

var _regeneratorRuntime = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var THREE = require("three");

var surface_1 = require("./surface");

var plate_1 = require("./plate");

var utils_1 = require("./utils");

var lodash_1 = require("lodash");

var ElementsManager = function ElementsManager(scene, render) {
  var _this = this;

  _classCallCheck(this, ElementsManager);

  this.surface = surface_1.surface;

  this.populatePlate = function (plateComponent) {
    _this.plateComponent = plateComponent;

    _this.populateFloor(plateComponent);

    _this.populateWall(plateComponent);

    _this.plate.update(plateComponent);

    _this.scene.add(_this.plate.mesh);
  };

  this.populateElements = function (elements) {
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var _this2 = this;

      var cornerRadius, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, element;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(elements && elements.length > 0)) {
                _context.next = 43;
                break;
              }

              cornerRadius = [];
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 5;
              _iterator = elements[Symbol.iterator]();

            case 7:
              if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                _context.next = 28;
                break;
              }

              element = _step.value;

              if (!element.isSubstraction) {
                _context.next = 13;
                break;
              }

              this.subtractElement(element); // this.subtractions.push(element);

              _context.next = 24;
              break;

            case 13:
              _context.t0 = element.type;
              _context.next = _context.t0 === 'wall' ? 16 : _context.t0 === 'trough' ? 18 : _context.t0 === 'corner-radius' ? 20 : 22;
              break;

            case 16:
              this.populateWall(element);
              return _context.abrupt("break", 24);

            case 18:
              this.populateTrough(element); // Have to await populating trough because it affects the children element positions

              return _context.abrupt("break", 24);

            case 20:
              cornerRadius.push(element);
              return _context.abrupt("break", 24);

            case 22:
              this.populateElement(element);
              return _context.abrupt("break", 24);

            case 24:
              // Populate child elements...
              if (typeof element.elements !== 'undefined' && element.type !== 'trough') {
                // Trough populates it's own later
                this.populateElements(element.elements);
              }

            case 25:
              _iteratorNormalCompletion = true;
              _context.next = 7;
              break;

            case 28:
              _context.next = 34;
              break;

            case 30:
              _context.prev = 30;
              _context.t1 = _context["catch"](5);
              _didIteratorError = true;
              _iteratorError = _context.t1;

            case 34:
              _context.prev = 34;
              _context.prev = 35;

              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }

            case 37:
              _context.prev = 37;

              if (!_didIteratorError) {
                _context.next = 40;
                break;
              }

              throw _iteratorError;

            case 40:
              return _context.finish(37);

            case 41:
              return _context.finish(34);

            case 42:
              // for populating corner radius
              cornerRadius.forEach(function (element) {
                _this2.populateCornerRadius(element);
              });

            case 43:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[5, 30, 34, 42], [35,, 37, 41]]);
    }));
  };

  this.populateCornerRadius = function (element) {
    // Add apron mesh
    var apronMesh = _this.generateLatheMesh(element);

    _this.mergeMeshWithPlate(apronMesh); // Cutout from plate


    var apronCut = _this.generateLatheMesh(element, element.thickness + 0.0001, 7); // this.subtractions.push(apronCut);


    _this.subtractMeshFromPlate(apronCut);
  };

  this.generateLatheMesh = function (element) {
    var adjustRadius = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var thickness = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var radius = element.scale && element.scale.x || 0;
    var points = [];
    radius = radius + adjustRadius;
    points.push(new THREE.Vector2(radius, 0)); // Inside bottom

    points.push(new THREE.Vector2(radius + element.thickness * thickness, 0)); // Outside bottom

    points.push(new THREE.Vector2(radius + element.thickness * thickness, element.scale.y)); // Outside top

    points.push(new THREE.Vector2(radius, element.scale.y)); // Inside top
    // for creating the back of the

    points.push(new THREE.Vector2(radius, 0));
    var edges = element.shape === 'radius' ? 64 : 1; // 1 is for making a flat surface and 16 is for making a circular object

    var geometry = new THREE.LatheGeometry(points, edges, 0.0, Math.PI / 2);
    var lastVertixIndex = geometry.vertices.length - 1;
    geometry.faces.push( // Front
    new THREE.Face3(0, 2, 3), new THREE.Face3(1, 2, 0), // Back
    new THREE.Face3(lastVertixIndex, lastVertixIndex - 1, lastVertixIndex - 2), new THREE.Face3(lastVertixIndex - 2, lastVertixIndex - 3, lastVertixIndex));

    var material = _this.surface.getMaterial(element.material);

    var mesh = new THREE.Mesh(geometry, material);
    utils_1.adjustTextureMapping(mesh.geometry);
    mesh.position.copy(element.position);
    mesh.position.y = mesh.position.y - element.scale.y / 2;
    mesh.position.z = mesh.position.z - element.thickness;

    if (element.isFirst) {
      mesh.position.x = mesh.position.x + element.thickness;
      mesh.rotateY(THREE.Math.degToRad(-90));
    } else {
      mesh.position.x = mesh.position.x - element.thickness;
    }

    geometry.colorsNeedUpdate = true;
    return mesh;
  };

  this.subtractElement = function (element) {
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      var mesh, object, _mesh;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // TODO - Fix race conditions... I think we need more awaits, because apron does not necessarily load first
              // Adding shape
              if (element.shape) {
                mesh = this.buildShapeMeshFromElement(element);

                if (mesh) {
                  // this.subtractions.push(mesh);
                  this.subtractMeshFromPlate(mesh);
                }
              } // Adding model


              if (!element.fileName) {
                _context2.next = 7;
                break;
              }

              _context2.next = 4;
              return this.buildModelMeshFromElement(element);

            case 4:
              object = _context2.sent;
              _mesh = utils_1.buildElementMeshFromObject(object, element, '');

              if (_mesh) {
                // this.subtractions.push(mesh);
                this.subtractMeshFromPlate(_mesh);
              }

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));
  };

  this.subtractMeshFromPlate = function (mesh) {
    _this.clearEntity(_this.plate.mesh);

    _this.plate.mesh = utils_1.subtractMeshFromMesh(_this.plate.mesh, mesh);

    _this.addEntity(_this.plate.mesh, false);

    _this.scene.remove(_this.plate.mesh);

    _this.scene.add(_this.plate.mesh);
  };

  this.mergeMeshWithPlate = function (mesh) {
    _this.clearEntity(_this.plate.mesh);

    _this.plate.mesh = utils_1.unionMeshFromMesh(_this.plate.mesh, mesh);

    _this.addEntity(_this.plate.mesh);
  };

  this.populateElement = function (element) {
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee3() {
      var object, mesh;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!element.fileName) {
                _context3.next = 6;
                break;
              }

              _context3.next = 3;
              return this.buildModelMeshFromElement(element);

            case 3:
              object = _context3.sent;

              if (element.type === 'tissue-dispenser-container') {
                object.scale.set(1, 1, 0.2);
              }

              this.addEntity(object);

            case 6:
              // Adding shape
              if (element.shape) {
                mesh = this.buildShapeMeshFromElement(element);

                if (mesh) {
                  if (element.type === 'apron') {
                    this.mergeMeshWithPlate(mesh);
                  } else {
                    this.addEntity(mesh);
                  }
                }
              }

            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));
  };

  this.buildModelMeshFromElement = function (element) {
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee4() {
      var object;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return utils_1.buildObject(element);

            case 2:
              object = _context4.sent;

              // Adding rotation... this doesn't affect inner elements
              if (typeof element.rotate !== 'undefined') {
                if (element.rotate.x) {
                  object.rotateX(THREE.Math.degToRad(element.rotate.x));
                }

                if (element.rotate.y) {
                  object.rotateY(THREE.Math.degToRad(element.rotate.y));
                }

                if (element.rotate.z) {
                  object.rotateZ(THREE.Math.degToRad(element.rotate.z));
                }
              }

              return _context4.abrupt("return", object);

            case 5:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
  };

  this.buildShapeMeshFromElement = function (element) {
    var mesh = null;

    if (element.shape === 'box') {
      var geometry = new THREE.BoxGeometry(element.scale.x, element.scale.y, element.scale.z);
      utils_1.adjustTextureMapping(geometry);
      mesh = new THREE.Mesh(geometry, _this.surface.getMaterial(element.material));
    } else if (element.shape === 'cylinder') {
      var _geometry = new THREE.CylinderGeometry(element.scale.x / 2, element.scale.x / 2, element.scale.y, 62);

      utils_1.adjustTextureMapping(_geometry);
      mesh = new THREE.Mesh(_geometry, _this.surface.getMaterial(element.material));
    }

    if (mesh) {
      mesh.position.copy(element.position);
    }

    return mesh;
  };

  this.populateTrough = function (element) {
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee5() {
      var object, notTrough, troughMesh, troughSize, box, troughScaleX, troughScaleZ, cut, geometry, cube, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, e, cornerRadius, squashFactor, plateSize, plateBounds, cornerGeometry, cylinderMesh, boxGeometry, boxMesh, invertedCylinderMesh, cornerMesh, overflowMesh, slinesMesh, drainMesh;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return utils_1.buildObject(element, 'troughs/');

            case 2:
              object = _context5.sent;
              // Trough
              notTrough = ['Schnittkoerper', 'drainposition', 'overflow', 'Abfluss', 'Plattenprofil'];
              troughMesh = utils_1.buildElementMeshesFromObject(object, element, '', notTrough)[0];

              if (!troughMesh) {
                _context5.next = 56;
                break;
              }

              // Calculate and adjust scale
              troughSize = new THREE.Vector3();
              box = new THREE.Box3().setFromObject(troughMesh);
              box.getSize(troughSize);
              troughScaleX = element.scale.x / troughSize.x;
              troughScaleZ = element.scale.x / troughSize.x;
              troughMesh.scale.set(troughScaleX, troughScaleX, troughScaleZ); // Cutout

              cut = utils_1.buildElementMeshFromObject(object, element, '_Schnittkoerper');

              if (!cut) {
                _context5.next = 18;
                break;
              }

              cut.scale.set(troughScaleX, troughScaleX, troughScaleZ); // this.subtractions.push(cut);

              this.subtractMeshFromPlate(cut);
              _context5.next = 46;
              break;

            case 18:
              // Position correction for backwall troughs...
              // Ideally this will be done by the plate-components provider, but we need more data (distance in mm from drain to back of trough) from Franke to do this
              element.position.z = element.position.z - box.min.z;
              troughMesh.position.copy(element.position); // Scale adjustment for backwall trough...

              troughScaleZ = element.scale.z / troughSize.z;
              troughMesh.scale.set(troughScaleX, troughScaleX, troughScaleZ); // Cut-out for backwall troughs...

              geometry = new THREE.BoxGeometry(element.scale.x, this.plateComponent.scale.y, 1);
              cube = new THREE.Mesh(geometry);
              cube.position.copy(this.plateComponent.position);
              cube.position.x = troughMesh.position.x;

              try {
                // this.subtractions.push(cube);
                this.subtractMeshFromPlate(cube);
              } catch (err) {
                console.error(err);
              } // Fixing child element positions since we've messed with the trough


              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _iteratorError2 = undefined;
              _context5.prev = 30;

              for (_iterator2 = element.elements[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                e = _step2.value;

                if (e.type !== 'towel-rail') {
                  e.position.z = e.position.z - box.min.z;
                  e.position.z = e.position.z * troughScaleZ;
                } else {
                  e.position.x = troughMesh.position.x;
                }
              }

              _context5.next = 38;
              break;

            case 34:
              _context5.prev = 34;
              _context5.t0 = _context5["catch"](30);
              _didIteratorError2 = true;
              _iteratorError2 = _context5.t0;

            case 38:
              _context5.prev = 38;
              _context5.prev = 39;

              if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
              }

            case 41:
              _context5.prev = 41;

              if (!_didIteratorError2) {
                _context5.next = 44;
                break;
              }

              throw _iteratorError2;

            case 44:
              return _context5.finish(41);

            case 45:
              return _context5.finish(38);

            case 46:
              // Subtract rounding from plate...
              if (element.fileName.includes('MEDCARE')) {
                // Radius of the rounded corner
                cornerRadius = this.plateComponent.scale.y / 2;
                squashFactor = 0.3; // Reduce to increase squash

                plateSize = new THREE.Vector3(this.plateComponent.scale.x, this.plateComponent.scale.y, this.plateComponent.scale.z);
                plateBounds = new THREE.Box3();
                plateBounds.min.set(this.plateComponent.position.x - plateSize.x / 2, this.plateComponent.position.y - plateSize.y / 2, this.plateComponent.position.z - plateSize.z / 2);
                plateBounds.max.set(this.plateComponent.position.x + plateSize.x / 2, this.plateComponent.position.y + plateSize.y / 2, this.plateComponent.position.z + plateSize.z / 2); // Create a cylinder

                cornerGeometry = new THREE.CylinderGeometry(cornerRadius, cornerRadius, plateSize.x, 66); // 46

                cornerGeometry.computeBoundingBox();
                cylinderMesh = new THREE.Mesh(cornerGeometry);
                cylinderMesh.rotation.z = Math.PI / 2;
                cylinderMesh.scale.set(1, 1, squashFactor); // this.addEntity(cylinderMesh);
                // Create a box that will be subtracted from the top half of the cylinder to get an inverted half-cylinder

                boxGeometry = new THREE.BoxGeometry(plateSize.x, 2 * cornerRadius, 2 * cornerRadius);
                boxMesh = new THREE.Mesh(boxGeometry);
                boxMesh.position.z = cylinderMesh.position.z + cornerRadius; // Place the box in the edge of the cylinder
                // this.addEntity(boxMesh);
                // Subtracting meshes

                invertedCylinderMesh = utils_1.subtractMeshFromMesh(boxMesh, cylinderMesh);
                invertedCylinderMesh.geometry.computeVertexNormals(); // this.addEntity(invertedCylinderMesh); // Looks good...

                cornerMesh = new THREE.Mesh(invertedCylinderMesh.geometry); // cornerMesh.rotation.z = Math.PI / 2;  // Rotate so the flat part aligns with the edge of the plate
                // Align the inverted half cylinder to the front edge of the plate

                cornerMesh.position.set(this.plateComponent.position.x, this.plateComponent.position.y, plateBounds.max.z + cornerRadius * (1 - squashFactor) - 0.0001); // Subtract from the plate

                this.subtractMeshFromPlate(cornerMesh);
              }

              if (typeof element.elements !== 'undefined') {
                this.populateElements(element.elements);
              } // Overflow


              overflowMesh = utils_1.buildElementMeshFromObject(object, Object.assign(Object.assign({}, element), {
                material: 'stainlessSteelDoubleSided'
              }), 'overflow');

              if (overflowMesh) {
                overflowMesh.scale.set(troughScaleX, troughScaleX, troughScaleZ);
                this.addEntity(overflowMesh);
              } // MEDCARE S lines


              slinesMesh = utils_1.buildElementMeshFromObject(object, Object.assign(Object.assign({}, element), {
                material: 'plainBlack'
              }), '_slines');

              if (slinesMesh) {
                slinesMesh.scale.set(troughScaleX, troughScaleX, troughScaleZ);
                this.addEntity(slinesMesh);
              } // Drain... only EXOS has the drain inside the trough model


              drainMesh = utils_1.buildElementMeshFromObject(object, Object.assign(Object.assign({}, element), {
                material: 'stainlessSteel'
              }), 'Abfluss');

              if (drainMesh) {
                drainMesh.scale.set(troughScaleX, troughScaleX, troughScaleZ);
                this.addEntity(drainMesh);
              }

              this.addEntity(troughMesh);
              this.populateMirror(troughMesh.position.x);

            case 56:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this, [[30, 34, 38, 46], [39,, 41, 45]]);
    }));
  };

  this.populateMirror = function (troughPosition) {
    var mirrorHeightOverPlate = 0.5;
    var wallMirror = new THREE.Object3D();
    var mirrorGeometry = new THREE.BoxGeometry(0.3, 0.6, 0.02, 1);
    var mirrorMesh = new THREE.Mesh(mirrorGeometry, _this.surface.getMaterial('mirror'));
    mirrorMesh.position.z = 0.005;
    wallMirror.add(mirrorMesh);
    var mirrorbackGeometry = new THREE.BoxGeometry(0.32, 0.62, 0.01, 1);
    var mirrorbackMesh = new THREE.Mesh(mirrorbackGeometry, _this.surface.getMaterial('mirrorBack'));
    wallMirror.add(mirrorbackMesh);
    wallMirror.position.x = troughPosition;
    wallMirror.position.y = _this.plate.mesh.position.y + mirrorHeightOverPlate;
    wallMirror.position.z = 0;

    _this.addEntity(wallMirror);
  };

  this.populateWall = function (element) {
    var isBackwall = element && element.scale && element.scale.x;
    var wallThickness = 0.1;
    var wallHeight = 5;
    var wallScaleX;
    var wallScaleY = wallHeight;
    var wallScaleZ;
    var wallPositionX = element && element.position.x;
    var wallPositionZ = -(wallThickness / 2);

    if (isBackwall) {
      wallScaleX = element.scale.x + wallThickness * 2 - 0.0002;
      wallScaleZ = wallThickness;
    } else {
      wallScaleX = 1;
      wallScaleZ = wallThickness;
      wallPositionZ = wallPositionZ + 0.5 - wallThickness / 2;

      if (element.isFirst) {
        wallPositionX = wallPositionX - wallThickness / 2;
      }

      if (element.isLast) {
        wallPositionX = wallPositionX + wallThickness / 2;
      }
    }

    var geometry = new THREE.BoxGeometry(wallScaleX, wallScaleY, wallScaleZ, 1);

    var material = _this.surface.getMaterial(_this.plateComponent.material === 'white' ? 'wallBlack' : 'wallWhite');

    var mesh = new THREE.Mesh(geometry, material);
    mesh.position.x = wallPositionX;
    mesh.position.z = wallPositionZ;

    if (!isBackwall) {
      mesh.rotation.y = Math.PI / 2;
    }

    utils_1.adjustTextureMapping(mesh.geometry);

    _this.addEntity(mesh);
  };

  this.populateFloor = function (plateComponent) {
    var geometry = new THREE.PlaneGeometry(10, 8, 10, 8);

    var material = _this.surface.getMaterial(plateComponent.material === 'white' ? 'floorTileBlack' : 'floorTileWhite');

    var mesh = new THREE.Mesh(geometry, material);
    mesh.rotateX(THREE.Math.degToRad(270));
    mesh.position.set(plateComponent.position.x, 0, 0);
    utils_1.adjustTextureMapping(mesh.geometry);

    _this.addEntity(mesh);
  };

  this.addEntity = function (entity) {
    var doSubtractions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (entity) {
      _this.entities.push(entity);

      _this.scene.add(entity);

      _this.render();
    }
  };

  this.clearEntity = function (entity) {
    if (entity) {
      utils_1.disposeEntity(entity);

      _this.scene.remove(entity);

      _this.entities = lodash_1.reject(_this.entities, function (e) {
        return e.uuid === entity.uuid;
      });

      _this.render();
    }
  };

  this.clear = function () {
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee6() {
      var _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, entity;

      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _iteratorNormalCompletion3 = true;
              _didIteratorError3 = false;
              _iteratorError3 = undefined;
              _context6.prev = 3;

              for (_iterator3 = this.entities[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                entity = _step3.value;
                this.clearEntity(entity);
              }

              _context6.next = 11;
              break;

            case 7:
              _context6.prev = 7;
              _context6.t0 = _context6["catch"](3);
              _didIteratorError3 = true;
              _iteratorError3 = _context6.t0;

            case 11:
              _context6.prev = 11;
              _context6.prev = 12;

              if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                _iterator3.return();
              }

            case 14:
              _context6.prev = 14;

              if (!_didIteratorError3) {
                _context6.next = 17;
                break;
              }

              throw _iteratorError3;

            case 17:
              return _context6.finish(14);

            case 18:
              return _context6.finish(11);

            case 19:
              this.entities = [];

            case 20:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, this, [[3, 7, 11, 19], [12,, 14, 18]]);
    }));
  };

  this.scene = scene;
  this.render = render;
  this.plate = new plate_1.default(); // Entities

  this.entities = [];
  this.memo = [];
};

exports.ElementsManager = ElementsManager;
exports.default = ElementsManager;